var _excluded = ["valid", "label", "validationMessage", "message", "onChange", "data-test-name", "className", "id", "resize", "fixedHeight", "minHeight", "maxHeight", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useEffect, useState } from "react";
import { DetailText } from "./Text";
import { invalidTextFieldStyle, textFieldStyles, TEXT_FIELD_HEIGHT } from "./TextField";
import { uniqueId } from "lodash/fp";
import { LabelFormElement } from "../..";
import { jsx as _jsx } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
import { jsxs as _jsxs } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
export function TextArea(_ref) {
  var _ref$valid = _ref.valid,
      valid = _ref$valid === void 0 ? true : _ref$valid,
      label = _ref.label,
      validationMessage = _ref.validationMessage,
      message = _ref.message,
      onChange = _ref.onChange,
      dataTestName = _ref["data-test-name"],
      className = _ref.className,
      id = _ref.id,
      _ref$resize = _ref.resize,
      resize = _ref$resize === void 0 ? "none" : _ref$resize,
      fixedHeight = _ref.fixedHeight,
      _ref$minHeight = _ref.minHeight,
      minHeight = _ref$minHeight === void 0 ? TEXT_FIELD_HEIGHT : _ref$minHeight,
      _ref$maxHeight = _ref.maxHeight,
      maxHeight = _ref$maxHeight === void 0 ? TEXT_FIELD_HEIGHT * 2 : _ref$maxHeight,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(id || uniqueId("TextAreaId")),
      _useState2 = _slicedToArray(_useState, 1),
      inputId = _useState2[0];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      touched = _useState4[0],
      setTouched = _useState4[1];

  var descriptionId = "".concat(inputId, "-description");
  var alertId = "".concat(inputId, "-alert");

  var handleChange = function handleChange(event) {
    var value = event.target.value;
    var target = event.target; // this is responsible for making the textarea's height grow with the text inside it.

    if (!fixedHeight) {
      target.style.height = "5px";
      target.style.height = "".concat(target.scrollHeight, "px");
    }

    if (onChange) {
      onChange(value);
    }
  }; // this is necessary to return the input to it's original size once the value is reset to ""


  useEffect(function () {
    var target = document.getElementById(inputId);

    if (!props.value && target) {
      target.style.height = "5px";
    }
  }, [props.value, inputId]);
  return _jsxs("div", {
    sx: {
      display: "flex",
      flexDirection: "column",
      gap: "xs",
      ":focus-within": _defineProperty({}, "#".concat(descriptionId), valid || !props.value && !touched ? visibleStyles : {})
    },
    onBlur: function onBlur() {
      if (!touched) setTouched(true);
    },
    className: className,
    children: [label && _jsx(LabelFormElement, {
      htmlFor: inputId,
      labelText: label
    }), _jsxs("div", {
      sx: {
        position: "relative",
        display: "flex",
        alignItems: "center"
      },
      children: [_jsx("textarea", _objectSpread({
        onChange: handleChange,
        "data-test-name": dataTestName,
        sx: _objectSpread(_objectSpread(_objectSpread({}, textFieldStyles), !valid && touched ? invalidTextFieldStyle : {}), {}, {
          resize: resize,
          minHeight: fixedHeight || minHeight,
          maxHeight: fixedHeight || maxHeight
        }, scrollbarStyles),
        id: inputId
      }, props)), children]
    }), validationMessage && !valid && touched && _jsx(DetailText, {
      id: alertId,
      color: "watermelon50",
      children: validationMessage
    }), message && _jsx(DetailText, {
      id: descriptionId,
      color: "dt_taro50",
      sx: _objectSpread({
        paddingLeft: "xs"
      }, invisibleStyles),
      children: message
    })]
  });
}
/**
 * it is important that this text is always rendered to help with context for screen readers
 */

var invisibleStyles = {
  position: "absolute",
  left: "-10000px",
  top: "auto",
  width: "1px",
  height: "1px",
  overflow: "hidden"
};
var visibleStyles = {
  position: "relative",
  left: "0",
  top: "0",
  width: "fit-content",
  height: "fit-content",
  overflow: "hidden"
};
var scrollbarStyles = {
  // Firefox
  scrollbarWidth: "auto",
  scrollbarColor: "#AAB0D8 transparent",

  /* Chrome, Edge, and Safari */
  "&::-webkit-scrollbar": {
    width: "20px"
  },
  "&::-webkit-scrollbar-track": {
    background: "transparent"
  },
  "&::-webkit-scrollbar-thumb": {
    borderRadius: "dt_radius_xs",
    boxShadow: "inset 0 0 10px 10px",
    color: "dt_taro40",
    border: "solid 6px transparent"
  }
};
//# sourceMappingURL=TextArea.js.map